import React, { useEffect, useState } from 'react';
import { useStore } from '../../app/stores/store';
import { useQuery } from '../../app/utils/hooks';
import { agent } from '../../app/api/agent';
import { toast } from 'react-toastify';
import { Button, Header, Icon, Segment } from 'semantic-ui-react';
import { LoginForm } from './LoginForm';

const STATUS = {
  Verifying: 'Verifying',
  Failed: 'Failed',
  Success: 'Success',
};

const ConfirmEmail: React.FC = () => {
  const { modalStore } = useStore();
  const email = useQuery().get('email') as string;
  const token = useQuery().get('token') as string;

  const [status, setStatus] = useState(STATUS.Verifying);

  async function confirmEmailResend() {
    try {
      await agent.Account.resendEmailConfirm(email);
      toast.success('Verification email resent - please check your email');
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(
    function verifyEmailOnMount() {
      agent.Account.verifyEmail(token, email)
        .then(() => {
          setStatus(STATUS.Success);
        })
        .catch(() => {
          setStatus(STATUS.Failed);
        });
    },
    [email, token],
  );

  const getBody = () => {
    switch (status) {
      case STATUS.Verifying:
        return <p>Verifying ...</p>;

      case STATUS.Failed:
        return (
          <div>
            <p>
              Verification failed. Try resending verification link to your email
            </p>
            <Button
              primary
              onClick={confirmEmailResend}
              size="huge"
              content="Resend email"
            />
          </div>
        );

      case STATUS.Success:
        return (
          <div>
            <p>Email has been verified - you can now login</p>
            <Button
              primary
              onClick={() => modalStore.openModal(<LoginForm />)}
              size="huge"
              content="Login"
            />
          </div>
        );
    }
  };

  return (
    <Segment textAlign="center">
      <Header>
        <Icon name="envelope" />
      </Header>
      <Segment.Inline>{getBody()}</Segment.Inline>
    </Segment>
  );
};

export { ConfirmEmail };
